// Google Analytics 4 tracking

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.log('[Analytics] GA_MEASUREMENT_ID not set, analytics disabled');
    return;
  }

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);

  console.log('[Analytics] Google Analytics initialized:', GA_MEASUREMENT_ID);
};

// Track page views
export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });

  console.log('[Analytics] Page view tracked:', path);
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;

  window.gtag('event', eventName, eventParams);

  console.log('[Analytics] Event tracked:', eventName, eventParams);
};

// Specific event trackers
export const trackTechSearch = (techSlugs) => {
  trackEvent('tech_search', {
    tech_slugs: techSlugs.join(','),
    tech_count: techSlugs.length,
  });
};

export const trackChartView = (chartType, techSlugs) => {
  trackEvent('chart_view', {
    chart_type: chartType,
    tech_slugs: techSlugs.join(','),
  });
};

export const trackError = (errorMessage) => {
  trackEvent('error', {
    error_message: errorMessage,
  });
};
